import { useEffect, useState } from 'react';
import { getCashDeposit } from '../services';
import { ICashDeposit } from '../types';
import { resolveErrorMessage } from './hookUtils';

interface SingleDepositState {
	deposit: ICashDeposit | null;
	loading: boolean;
	error: string | null;
	refetch: () => void;
}

export function useCashDeposit(depositId: number | string | undefined): SingleDepositState {
	const [deposit, setDeposit] = useState<ICashDeposit | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [tick, setTick] = useState(0);

	useEffect(() => {
		if (!depositId) {
			setLoading(false);
			return;
		}

		let cancelled = false;
		setLoading(true);
		setError(null);

		getCashDeposit(depositId)
			.then(({ data }) => {
				if (!cancelled) {
					setDeposit(data);
					setLoading(false);
				}
			})
			.catch((err) => {
				if (!cancelled) {
					setError(resolveErrorMessage(err));
					setLoading(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [depositId, tick]);

	return { deposit, loading, error, refetch: () => setTick((t) => t + 1) };
}
